// File: src/pages/Projects.js
import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { Routes, Route, Navigate, Link } from "react-router-dom";
import { MobileViewContext } from "../context/MobileViewContext";
import SecondarySidebarBasic from "../components/SecondarySidebarBasic";
import "./Projects.css"

const projectItems = [
  { label: "Jous", route: "/projects/jous" },
  { label: "Melting Pots", route: "/projects/melting-pots" },
  { label: "Second Date", route: "/projects/second-date" },
  { label: "Tango Diario", route: "/projects/tango-diario" },
  { label: "Telegram bots", route: "/projects/telegram" },
];

function ProjectsHome() {
  return (
    <div>
      <Helmet>
        <title>Projects | Helia Jamshidi</title>
        <meta
          name="description"
          content="Overview of personal and experimental projects by Helia Jamshidi."
        />
        <meta
          name="keywords"
          content="Helia Jamshidi projects, Jous, Melting Pots, Second Date, Tango Diario, Telegram bots"
        />
        <meta property="og:title" content="Projects | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Discover apps and tools Helia is building or experimenting with."
        />
        <meta property="og:url" content="https://heliajamshidi.me/projects" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects" />
      </Helmet>
      <h2>Projects Overview</h2>
      <p>Choose a project to findout more about it.</p>
    </div>
  );
}

function Jous() {
  return (
    <div>
      <Helmet>
        <title>Jous Conversation Cards | Helia Jamshidi</title>
        <meta
          name="description"
          content="Community app with conversation questions to spark meaningful dialogue."
        />
        <meta property="og:title" content="Jous Conversation Cards | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Discover Jous, an app for avoiding small talk and connecting over thoughtful questions."
        />
        <meta property="og:url" content="https://heliajamshidi.me/projects/jous" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects/jous" />
      </Helmet>
      <h1>Jous Conversation Cards</h1>
      <p>This App is for people trying to avoid small talk. It is a cozy community for questions that spark conversations. But it is not Reddit! To answer questions in Jous, you should search inward, inside yourself. For families, friends, dates, and strangers. Anyone can share questions on Jous, the question set changes daily.</p>
      <div className="sample-images-section">
        <div className="image-gallery" >
          <iframe
            src="https://jous.app"
            title="Jous app"
            className="app-embed"
          ></iframe>
          <button
            className="visit-btn"
            onClick={() => window.open('https://jous.app', '_blank')}
          >
            Visit App
          </button>
        </div>
      </div>
    </div>
  );
}

function SecondDate() {
  return (
    <div>
      <Helmet>
        <title>Second Date | Helia Jamshidi</title>
        <meta
          name="description"
          content="Swipe through fun date ideas contributed by the community."
        />
        <meta property="og:title" content="Second Date | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Explore Helia's experiment to make dating less like work."
        />
        <meta property="og:url" content="https://heliajamshidi.me/projects/second-date" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects/second-date" />
      </Helmet>
      <h1>Second Date</h1>
      <p>Swipe-based collection of first-date ideas aimed at making dates playful and engaging.</p>
      <div className="sample-images-section">
        <div className="image-gallery" >
          <iframe
            src="https://seconddate.date/swipe"
            title="Second Date app"
            className="app-embed"
          ></iframe>
          <button
            className="visit-btn"
            onClick={() => window.open('https://seconddate.date/swipe', '_blank')}
          >
            Visit App
          </button>
        </div>
      </div>
    </div>
  );
}

function TangoDiario() {
  return (
    <div>
      <Helmet>
        <title>Tango Diario | Helia Jamshidi</title>
        <meta
          name="description"
          content="A daily five-minute practice tool for tango musicality."
        />
        <meta property="og:title" content="Tango Diario | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Practice tango musicality step by step with weekly topics."
        />
        <meta property="og:url" content="https://heliajamshidi.me/projects/tango-diario" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects/tango-diario" />
      </Helmet>
      <h1>Tango Diario</h1>
      <p>Practice tango musicality with short daily exercises and weekly themes.</p>
      <div className="sample-images-section">
        <div className="image-gallery" >
          <iframe
            src="https://tango-diario.com/"
            title="Tango Diario app"
            className="app-embed"
          ></iframe>
          <button
            className="visit-btn"
            onClick={() => window.open('https://tango-diario.com/', '_blank')}
          >
            Visit App
          </button>
        </div>
      </div>
    </div>
  );
}

const meltingPotsPages = [
  {
    name: "Art Explorer",
    url: "https://art.meltingpots.org",
    text: "Journey through decades and regions to discover iconic works in visual arts, music, and literature.",
  },
  {
    name: "Emotion Explorer",
    url: "https://emotion.meltingpots.org",
    text: "Discover art through the lens of human emotion: joy, melancholy, wonder, and beyond.",
  },
  {
    name: "The Tyler Index",
    url: "https://tyler.meltingpots.org",
    text: "Every recommendation from Conversations with Tyler: books, music, food, and places, mapped.",
  },
  {
    name: "EU vs the World",
    url: "https://eudemocracy.meltingpots.org",
    text: "125 years of democracy, charted. How Europe's democracies compare across a century of data.",
  },
  {
    name: "Historical Sparks",
    url: "https://events.meltingpots.org",
    text: "A world map with time playing: sparks fire where and when breakthroughs happened, in science, literature, rights and institutions.",
  },
  {
    name: "What Counts as a Number",
    url: "https://numbers.meltingpots.org",
    text: "Writing numbers is ancient, believing in them is new: a timeline of both, with ten arguments from the moments each number did not yet officially exist.",
  },
  {
    name: "Nine Ways to Stop Food Rotting",
    url: "https://food-preservation.meltingpots.org",
    text: "Microbes need water, warmth and air. Every way of keeping food takes one of those away, and there are only nine of them. 70 methods, in pictures.",
  },
  {
    name: "The 218",
    url: "https://iran.meltingpots.org",
    text: "The people who explain modern Iran, 1800 to 2026: an influence timeline, who made whom, and the longer story behind each name.",
  },
  {
    name: "The Big Battalions",
    url: "https://military.meltingpots.org",
    text: "The three to five strongest militaries of every age, century by century and then decade by decade, with the map keeping pace.",
  },
];

function MeltingPots() {
  return (
    <div className="container">
      <Helmet>
        <title>Melting Pots | Helia Jamshidi</title>
        <meta
          name="description"
          content="A collection of interactive pages exploring art, culture, and history across time and borders, built with AI."
        />
        <meta property="og:title" content="Melting Pots | Helia Jamshidi" />
        <meta
          property="og:description"
          content="Explore Melting Pots: interactive pages on art, emotion, democracy, history, and more, each crossing a border of geography or time."
        />
        <meta property="og:url" content="https://heliajamshidi.me/projects/melting-pots" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects/melting-pots" />
      </Helmet>
      <h1>Melting Pots</h1>
      <p>
        A project to melt the world: a growing collection of interactive pages exploring
        the fusion of art, culture, and human expression across time and borders.
      </p>
      <p>
        The pages probably look random, but they share three threads. First, almost every
        one compares, connects, or references across some border, whether geography or
        centuries. Second, they all use AI extensively: since the first version of ChatGPT,
        what struck me was not how deep its knowledge was, but how wide. No human could
        ever know so many languages and so many traditions at once. That knowledge stays
        buried if nothing is asked, and these projects are my way of probing the models to
        tell us what they know. Third, interfaces: the web is the most flexible medium we
        have, so each page tries to find the form that fits its story best, something
        interactive, fast, and complementary to the story itself.
      </p>
      <h2>The Pages</h2>
      <div className="subproject-list">
        {meltingPotsPages.map((page) => (
          <div className="subproject-item" key={page.url}>
            <h3>
              <a href={page.url} target="_blank" rel="noopener noreferrer">
                {page.name}
              </a>
            </h3>
            <p>{page.text}</p>
          </div>
        ))}
      </div>
      <div className="sample-images-section">
        <div className="image-gallery" >
          <iframe
            src="https://meltingpots.org"
            title="Melting Pots"
            className="app-embed"
          ></iframe>
          <button
            className="visit-btn"
            onClick={() => window.open('https://meltingpots.org', '_blank')}
          >
            Visit App
          </button>
        </div>
      </div>
    </div>
  );
}

const telegramBots = [
  {
    handle: "ru_fa_sub_bot",
    logo: "/images/telegram/ru_fa_sub_bot.jpg",
    line: "Send it Persian or Russian, as text or a voice message, and it tells you how to read it and what it means in English.",
  },
  {
    handle: "adam_smith_h_dm_bot",
    logo: "/images/telegram/adam_smith_h_dm_bot.jpg",
    line: "Mention it in a group chat and it answers with an Adam Smith quote that fits the conversation.",
  },
  {
    handle: "three_poets_h_bot",
    letter: "P",
    line: "Replies with a line from Shakespeare, Hafez or Saadi that fits what you want to say.",
  },
  {
    handle: "jous_app_bot",
    logo: "/images/telegram/jous_app_bot.jpg",
    line: "Sends you a non small talk personal question.",
  },
  {
    handle: "rss_h_bot",
    letter: "R",
    line: "RSS reader: paste a feed link and every morning it sends what is new, right in the chat.",
  },
];

function TelegramBots() {
  return (
    <div className="container">
      <Helmet>
        <title>Telegram Bots | Helia Jamshidi</title>
        <meta
          name="description"
          content="Small Telegram bots for fun by Helia Jamshidi: a Persian and Russian reading helper, an Adam Smith quote bot, a poets bot, the Jous question bot and a personal RSS reader."
        />
        <meta property="og:title" content="Telegram Bots | Helia Jamshidi" />
        <meta property="og:description" content="Small bots for fun in Telegram." />
        <meta property="og:url" content="https://heliajamshidi.me/projects/telegram" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://heliajamshidi.me/projects/telegram" />
      </Helmet>
      <h1>Telegram Bots</h1>
      <p>Small bots for fun in Telegram.</p>
      <ul className="telegram-bots">
        {telegramBots.map((bot) => (
          <li key={bot.handle}>
            {bot.logo ? (
              <img className="tg-avatar" src={bot.logo} alt={`@${bot.handle} logo`} />
            ) : (
              <span className="tg-avatar tg-avatar-letter">{bot.letter}</span>
            )}
            <div>
              <a
                className="tg-handle"
                href={`https://t.me/${bot.handle}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                @{bot.handle}
              </a>
              <p>{bot.line}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Projects({isMobile}) {
    const {contentIsVisibleMobile, toc2IsVisibleMobile } = useContext(MobileViewContext);
  return (
    <div className="content-with-sub">
      {(!isMobile || toc2IsVisibleMobile) && 
      <SecondarySidebarBasic heading="Projects" items={projectItems} />}
      {(!isMobile || contentIsVisibleMobile) && 
      <div className="content-area">
        <Routes>
          <Route path="/" element={<ProjectsHome />} />
          <Route path="/jous" element={<Jous />} />
          <Route path="/second-date" element={<SecondDate />} />
          <Route path="/tango-diario" element={<TangoDiario />} />
          <Route path="/melting-pots" element={<MeltingPots />} />
          <Route path="/telegram" element={<TelegramBots />} />
          <Route path="/telegram/*" element={<Navigate to="/projects/telegram" replace />} />
          <Route path="/eu-democracy" element={<Navigate to="/projects/melting-pots" replace />} />
        </Routes>
      </div>}
    </div>
  );
}
